import {
  ErrorType,
  type DceNotAllowedByOrder,
  type ErrorValues
} from 'commons/utils/errors/error-type';
import { Order } from 'commons/utils/types/dashboard-response-dto';

type DashboardError = {
  type: ErrorType | null;
  orders?: Order[];
  values?: ErrorValues;
};

export type DashboardState = {
  orders: Order[];
  error?: DashboardError | undefined;
  labelsUrls?: string[];
  contentDeclarationsUrls?: string[];
  errorsMissingFiscalInformation?: string[];
  errorsDceNotAllowed?: DceNotAllowedByOrder;
  savings?: number;
  ifoodTrackingOrders?: Order[];
};

export type Action =
  | {
      type: 'DEFINE_ORDERS';
      payload: Order[];
    }
  | {
      type: 'SET_LABELS_URLS';
      payload: string[];
    }
  | {
      type: 'SET_CONTENT_DECLARATIONS_URLS';
      payload: string[];
    }
  | {
      type: 'MISSING_FISCAL_INFORMATION_DOCUMENT_ERROR';
      payload: string[];
    }
  | {
      type: 'CORREIOS_DCE_INELEGIBLE_MERCHANT';
      payload: string[];
    }
  | {
      type: 'CORREIOS_DCE_POLLING_EXHAUSTED_ERROR';
      payload: string[];
    }
  | {
      type: 'SET_ERRORS_DCE_NOT_ALLOWED';
      payload: DceNotAllowedByOrder;
    }
  | {
      type: 'SET_SAVINGS';
      payload: number;
    }
  | {
      type: 'SET_IFOOD_TRACKING_ORDERS';
      payload: Order[];
    }
  | {
      type: 'SET_ERROR';
      payload: DashboardError;
    }
  | {
      type: 'CLEAR_ERROR';
    }
  | {
      type: 'CLEAR_ERRORS_MISSING_FISCAL_INFORMATION';
    };

const initialState: DashboardState = {
  orders: [],
  error: {
    type: null
  },
  savings: 0
};

const dashboardReducer = (
  state: DashboardState,
  action: Action
): DashboardState => {
  switch (action.type) {
    case 'DEFINE_ORDERS':
      return { ...state, orders: action.payload };

    case 'SET_ERROR':
      return { ...state, error: action.payload };

    case 'SET_LABELS_URLS':
      return { ...state, labelsUrls: action.payload };

    case 'SET_CONTENT_DECLARATIONS_URLS':
      return { ...state, contentDeclarationsUrls: action.payload };

    case 'SET_SAVINGS':
      return { ...state, savings: action.payload };

    case 'SET_IFOOD_TRACKING_ORDERS':
      return { ...state, ifoodTrackingOrders: action.payload };

    case 'MISSING_FISCAL_INFORMATION_DOCUMENT_ERROR':
      return {
        ...state,
        errorsMissingFiscalInformation: action.payload,
        error: {
          type: ErrorType.MISSING_FISCAL_INFORMATION_DOCUMENT_ERROR
        }
      };
    case 'CORREIOS_DCE_INELEGIBLE_MERCHANT':
      return {
        ...state,
        errorsMissingFiscalInformation: action.payload,
        error: {
          type: ErrorType.CORREIOS_DCE_INELEGIBLE_MERCHANT
        }
      };
    case 'CORREIOS_DCE_POLLING_EXHAUSTED_ERROR':
      return {
        ...state,
        errorsMissingFiscalInformation: action.payload,
        error: {
          type: ErrorType.CORREIOS_DCE_POLLING_EXHAUSTED_ERROR
        }
      };

    case 'SET_ERRORS_DCE_NOT_ALLOWED':
      return { ...state, errorsDceNotAllowed: action.payload };

    case 'CLEAR_ERROR':
      return { ...state, error: undefined };

    case 'CLEAR_ERRORS_MISSING_FISCAL_INFORMATION':
      return {
        ...state,
        errorsMissingFiscalInformation: undefined,
        errorsDceNotAllowed: undefined
      };

    default:
      return state;
  }
};

export { initialState, dashboardReducer };
